module["exports"] = ["gmail.com", "yahoo.co.kr", "hanmail.net", "naver.com"];